export const assetNameCharacterLimit = 100
export const descriptionCharacterLimit = 250
